import { useLayoutEffect, useRef } from "react";

/** Fits a textarea to its content up to `maxHeightPx`; overflow then scrolls inside the field. */
export function useChatComposeAutogrow(value: string, maxHeightPx: number) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, maxHeightPx)}px`;
  }, [value, maxHeightPx]);

  return ref;
}
